// Author YuJiaBei
// Date 2020-12-02 16:57:54

class EmAclRoleAcl {
constructor({
        id = null,
        roleId = '',
        aclId = ''}
= {}) {
    this.id = id;
    this.roleId = roleId;
    this.aclId = aclId;
}
}

function newEntity() {
return new EmAclRoleAcl();
}

    function gridFields() {
    return Object.freeze([
        {
        key: 'roleName',
        label: 'label.em.admin.emAclRoleAcl.grid.roleName',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'roleStatus',
        label: 'label.em.admin.emAclRoleAcl.grid.roleStatus',
        sortable: true,
        form: {
        type: 'select'
        ,options: [
                { value: '1', text: '启用' },
                            { value: '2', text: '冻结' }
            ]
        }
        },
        {
        key: 'roleType',
        label: 'label.em.admin.emAclRoleAcl.grid.roleType',
        sortable: true,
        form: {
        type: 'select'
        ,options: [
                { value: '1', text: '管理员' },
                            { value: '2', text: '普通用户' }
            ]
        }
        },
        {
        key: 'roleAclLevel',
        label: 'label.em.admin.emAclRoleAcl.grid.roleAclLevel',
        sortable: true,
        form: {
        type: 'select'
        ,options: [
                { value: '1', text: '读写' },
                            { value: '2', text: '只读' }
            ]
        }
        },
        {
        key: 'roleDeptAclLevel',
        label: 'label.em.admin.emAclRoleAcl.grid.roleDeptAclLevel',
        sortable: true,
        form: {
        type: 'select'
        ,options: [
                { value: '1', text: '无限制' },
                            { value: '4', text: '本部门及子部门' },
                            { value: '6', text: '仅本部门' }
            ]
        }
        },
        {
        key: 'aclParentId',
        label: 'label.em.admin.emAclRoleAcl.grid.aclParentId',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'aclName',
        label: 'label.em.admin.emAclRoleAcl.grid.aclName',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'aclLevel',
        label: 'label.em.admin.emAclRoleAcl.grid.aclLevel',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'aclType',
        label: 'label.em.admin.emAclRoleAcl.grid.aclType',
        sortable: true,
        form: {
        type: 'select'
        ,options: [
                { value: 'routerCard', text: '路由卡' },
                            { value: 'menuRouter', text: '面包屑菜单' },
                            { value: 'aclPoint', text: '权限点' },
                            { value: 'project', text: '项目' },
                            { value: 'routerCardSetting', text: '路由卡配置项' },
                            { value: 'routerCardItem', text: '路由卡项目' },
                            { value: 'editCard', text: '编辑卡' }
            ]
        }
        },
        {
        key: 'aclSeq',
        label: 'label.em.admin.emAclRoleAcl.grid.aclSeq',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'aclStatus',
        label: 'label.em.admin.emAclRoleAcl.grid.aclStatus',
        sortable: true,
        form: {
        type: 'select'
        ,options: [
                { value: '1', text: '启用' },
                            { value: '2', text: '冻结' }
            ]
        }
        },
        {
        key: 'aclUrl',
        label: 'label.em.admin.emAclRoleAcl.grid.aclUrl',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'menuUrl',
        label: 'label.em.admin.emAclRoleAcl.grid.menuUrl',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'aclWorkflowDefinitionKey',
        label: 'label.em.admin.emAclRoleAcl.grid.aclWorkflowDefinitionKey',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'aclRemark',
        label: 'label.em.admin.emAclRoleAcl.grid.aclRemark',
        sortable: true,
        form: {
        type: 'input'
        }
        }
    ])}

const filter = {
    roleIdSetFilter : "",
    roleIdFilter : "",
    aclIdFilter : "",
    roleTypeFilter : "",
    roleStatusFilter : "",
    roleAclLevelFilter : "",
    roleDeptAclLevelFilter : "",
    aclParentIdFilter : "",
    aclNameFilter : "",
    aclLevelFilter : "",
    aclTypeFilter : "",
    aclStatusFilter : "",
    aclUrlFilter : "",
    aclWorkflowDefinitionKeyFilter : ""
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'roleIdSetFilter',
        label: 'label.em.admin.emAclRoleAcl.filter.roleIdSet',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'roleIdFilter',
        label: 'label.em.admin.emAclRoleAcl.filter.roleId',
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'emAclRole'
            ,correspondingField: 'id'
                }
        },
        {
        key: 'aclIdFilter',
        label: 'label.em.admin.emAclRoleAcl.filter.aclId',
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'emMenu'
            ,correspondingField: 'id'
                }
        },
        {
        key: 'roleTypeFilter',
        label: 'label.em.admin.emAclRoleAcl.filter.roleType',
        disabled: false,
        form: {
        type: 'select'
            ,showLabelSelectOne: true
         ,options: [
                { value: '1', text: '管理员' },
                { value: '2', text: '普通用户' }
            ]
        }
        },
        {
        key: 'roleStatusFilter',
        label: 'label.em.admin.emAclRoleAcl.filter.roleStatus',
        disabled: false,
        form: {
        type: 'select'
            ,showLabelSelectOne: true
         ,options: [
                { value: '1', text: '启用' },
                { value: '2', text: '冻结' }
            ]
        }
        },
        {
        key: 'roleAclLevelFilter',
        label: 'label.em.admin.emAclRoleAcl.filter.roleAclLevel',
        disabled: false,
        form: {
        type: 'select'
            ,showLabelSelectOne: true
         ,options: [
                { value: '1', text: '读写' },
                { value: '2', text: '只读' }
            ]
        }
        },
        {
        key: 'roleDeptAclLevelFilter',
        label: 'label.em.admin.emAclRoleAcl.filter.roleDeptAclLevel',
        disabled: false,
        form: {
        type: 'select'
            ,showLabelSelectOne: true
         ,options: [
                { value: '1', text: '无限制' },
                { value: '4', text: '本部门及子部门' },
                { value: '6', text: '仅本部门' }
            ]
        }
        },
        {
        key: 'aclParentIdFilter',
        label: 'label.em.admin.emAclRoleAcl.filter.aclParentId',
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'emAclAcl'
            ,correspondingField: 'id'
                }
        },
        {
        key: 'aclNameFilter',
        label: 'label.em.admin.emAclRoleAcl.filter.aclName',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'aclLevelFilter',
        label: 'label.em.admin.emAclRoleAcl.filter.aclLevel',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'aclTypeFilter',
        label: 'label.em.admin.emAclRoleAcl.filter.aclType',
        disabled: false,
        form: {
        type: 'select'
            ,showLabelSelectOne: true
         ,options: [
                { value: 'routerCard', text: '路由卡' },
                { value: 'menuRouter', text: '面包屑菜单' },
                { value: 'aclPoint', text: '权限点' },
                { value: 'project', text: '项目' },
                { value: 'routerCardSetting', text: '路由卡配置项' },
                { value: 'routerCardItem', text: '路由卡项目' },
                { value: 'editCard', text: '编辑卡' }
            ]
        }
        },
        {
        key: 'aclStatusFilter',
        label: 'label.em.admin.emAclRoleAcl.filter.aclStatus',
        disabled: false,
        form: {
        type: 'select'
            ,showLabelSelectOne: true
         ,options: [
                { value: '1', text: '启用' },
                { value: '2', text: '冻结' }
            ]
        }
        },
        {
        key: 'aclUrlFilter',
        label: 'label.em.admin.emAclRoleAcl.filter.aclUrl',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'aclWorkflowDefinitionKeyFilter',
        label: 'label.em.admin.emAclRoleAcl.filter.aclWorkflowDefinitionKey',
        disabled: false,
        form: {
        type: 'input'
                }
        }
];


    const entityFormConfigs = [
        {
        key: 'roleId',
        label: 'label.em.admin.emAclRoleAcl.entity.roleId',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'emAclRole'
            ,correspondingField: 'id'
                }
        },
        {
        key: 'aclId',
        label: 'label.em.admin.emAclRoleAcl.entity.aclId',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'emAclAcl'
            ,correspondingField: 'id'
                }
        }
]

export {EmAclRoleAcl, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
, filterConfigs


}
